var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-editor"},[_c('Datepicker',{ref:"datepicker",style:({ border: 0 }),attrs:{"value":_vm.selectedDate,"calendar-class":"datepicker-calendar","inline":true,"monday-first":true},on:{"selected":_vm.setDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }